<template>
  <popover placement="top">
    <span :class="['af-icons', 'af-icons-help', alignment]"></span>
    <div slot="content">
      {{ text }}
    </div>
  </popover>
</template>

<script>
import { Popover } from 'vue-bootstrap';
import { stripTags } from '../../string';

export default {
  components: {
    Popover
  },
  props: {
    content: {
      type: String,
      required: true
    },
    align: {
      type: String,
      default: ''
    }
  },
  computed: {
    alignment() {
      return this.align !== '' ? `align-${this.align}` : '';
    },
    text() {
      return stripTags(this.content);
    }
  }
};
</script>
